export const SCHEDULER_VIEWS = {
    productionTimelineView: 'productionTimeline',
    multiLocationView: 'multiLocation',
    personalVerticalModeView: 'personalVerticalModeView',
    crossProductionView: 'crossProduction',
    verticalModeView: 'verticalModeView'
};

export const MAX_CALENDAR_RANGE = 10 * 365 * 24 * 3600000; // 10 years in milliseconds

export const SCHEDULER_STORE_KEY = {
    name: 'name'
};

export const TEMP_NAME = {
    activity: 'Temp Activity'
};

export const MOVE_SCHEDULER_NAME = {
    production: 'moveProductionSchedule'
};

export const SCHEDULER_INDEX_DB_TABLE = {
    schedulerStores: 'schedulerStores',
    schedulerProductionData: 'schedulerProductionData'
};

export const BRYNTUM_CALENDAR_FIELDS = {
    calendar: 'Calendar'
};

export const BRYNTUM_EVENT_FIELDS = {
    name: 'name',
    duration: 'duration',
    durationUnit: 'durationUnit',
    hasError: 'hasError',
    srType: 'sr-type',
    generatedId: 'generatedId',
    dateRange: 'dateRange',
    security: 'security',
    attributes: 'attributes'
};

export const TIME_UNITS = {
    second: 'second',
    minute: 'minute',
    day: 'day',
    hour: 'hour',
    week: 'week',
    month: 'month',
    quarter: 'quarter',
    year: 'year'
} as const;

export const BRYNTUM_EVENT_ICONS = {
    ERROR: 'bryntum-circle-exclamation',
    FLAG: 'b-fa b-fa-fw b-fa-flag',
    EDIT: 'b-fa b-fa-fw b-fa-edit',
    DELETE: 'b-fa b-fa-fw b-fa-trash',
    DETAILS: 'b-fa b-fa-fw b-fa-dollar-sign',
    MOVE: 'b-fa b-fa-fw b-fa-calendar'
};

export const SORT_BY_DATES = {
    endDateASC: 'enddate_ASC',
    endDateDESC: 'enddate_DESC'
};

export const ACTIVITY_CONTEXT_SOURCES = {
    RESERVATION: 'reservation',
    PRODUCTION: 'production'
};

export const SCHEDULER_PRESETS = {
    year: 'yearCustom',
    next12Months: 'next12Months',
    quarter: 'quarter',
    month: 'month',
    weekCustom: 'weekCustom',
    dayCustom: 'dayCustom',
    next30Days: 'next30Days'
};

export const BACKWARD_COMPATIBLE_PRESETS = {
    year: 'year',
    week: 'week',
    day: 'day'
};

export const SCHEDULER_INDEX_DB_STATUS = {
    in_progress: 'in_progress',
    complete: 'complete',
    failed: 'failed'
};

export const SCHEDULER_DISPLAY_DATE_FORMAT = 'MMM DD, YYYY';

export const SCHEDULER_PRESET_ID_SUFFIX = '_viewPreset';

export const END_OF_DAY = '235959';
export const START_OF_DAY = '000000';
export const MS_PER_HOUR = 60 * 60 * 1000;
export const MULTI_DAY_THRESHOLD_HOURS = 24;

export const SSE_SUPPORTED_VIEWS = [
    SCHEDULER_VIEWS.multiLocationView,
    SCHEDULER_VIEWS.crossProductionView,
    SCHEDULER_VIEWS.productionTimelineView
];

export const PRODUCTION_PLANNING_VIEWS = [SCHEDULER_VIEWS.crossProductionView, SCHEDULER_VIEWS.productionTimelineView];

export const RESERVATION_MANAGEMENT_VIEWS = [SCHEDULER_VIEWS.multiLocationView, SCHEDULER_VIEWS.verticalModeView];

export const ACTIVITY_CHUNK_SIZE = 2;
export const RESERVATION_CHUNK_SIZE = 2;
export const SCHEDULER_SEARCH_BATCH_SIZE = 200;

export const SCHEDULE_WIDGET_DISABLED_UNITS = ['second', 'minute'];

export const BRYNTUM_RESOURCES_SORTABLE_FIELD = 'name';
